import React from 'react';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'planificacion' | 'en_curso' | 'finalizada' | 'success' | 'warning' | 'danger' | 'info' | 'prerregistrado';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'default',
  size = 'md',
  className = ''
}) => {
  const baseClasses = 'inline-flex items-center font-semibold rounded-full';

  const variantClasses = {
    default: 'bg-slate-100 text-slate-700',
    planificacion: 'bg-blue-100 text-blue-700',
    en_curso: 'bg-green-100 text-green-700',
    finalizada: 'bg-slate-100 text-slate-700',
    success: 'bg-emerald-100 text-emerald-700',
    warning: 'bg-yellow-100 text-yellow-700',
    danger: 'bg-red-100 text-red-700',
    info: 'bg-blue-100 text-blue-700',
    prerregistrado: 'bg-orange-100 text-orange-700'
  };

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-xs',
    lg: 'px-4 py-1.5 text-sm'
  };

  return (
    <span className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}>
      {children}
    </span>
  );
};
